import { SearchElement } from './search';

import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('search-toggle')
export class SearchToggle extends LitElement {


    // Lifecycle Hooks

    firstUpdated() {
        this.classList.add('SearchToggle');
        const search: SearchElement = document.querySelector(`search-element`);
        this.addEventListener('click', () => {
            search.open();
        });
    }

    // Render

    createRenderRoot() {
        return this;
    }

}